import { CashTransactionGroupType } from '@pflegenavi/shared/api';

/**
 * Whether a cash transaction group can be assigned to expense management.
 *
 * Per spec, only Auszahlung-style groups qualify, and only when no other links
 * exist and the group has not yet been assigned to expense management.
 *
 * Also requires a non-zero `cashChangedCents` so we never create a 0-amount
 * expense, which would be meaningless and likely indicates the field wasn't
 * fetched.
 */
export function isAssignToExpenseEligible(row: {
  type: CashTransactionGroupType;
  amountLinkedCents?: number;
  cashChangedCents?: number;
  expensePartCount?: number;
}): boolean {
  const isWithdrawalGroup =
    row.type === CashTransactionGroupType.ReceiptWithdrawal ||
    row.type === CashTransactionGroupType.ResidentWithdrawal;
  const hasAmount =
    row.cashChangedCents !== undefined && row.cashChangedCents !== 0;
  const notAssigned = (row.expensePartCount ?? 0) === 0;
  return (
    isWithdrawalGroup &&
    (row.amountLinkedCents ?? 0) === 0 &&
    hasAmount &&
    notAssigned
  );
}
